export default "__VITE_ASSET__C3A5ddE1__"